export default class SimpleHeaderFastNavigation {
    constructor() {
        this.section = document.querySelector('.simpleHeaderFastNavigation');
        this.listItems = this.section.querySelectorAll('.fastNavItem');
        this.headerContent = document.querySelectorAll('.text-content h2');
        this.ready();
    }

    ready() {
        this.listItems.forEach((el) => {
            el.addEventListener('click', () => {
                const object = el.dataset.item;
                this.headerContent.forEach((element) => {
                    if (element.textContent === object) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                        });
                    }
                });
            });
        });
    }
}
document.querySelector('.simpleHeaderFastNavigation') ? new SimpleHeaderFastNavigation() : null;
